'use strict';

const _=require('pulsar-utils/dist-es6/_');
const treeUtils=require('pulsar-utils/dist-es6/treeUtils');
const TimeInterval=require('pulsar-utils/dist-es6/timeInterval');
const timespan=require('pulsar-utils/dist-es6/time/timespan');
const LiveGroupBasedDataService=require('../../../dist-es6/client/services/liveGroupBasedDataService');
const SocketResponse=require('../../../dist-es6/client/dtos/socketResponse');

const SixHoursInMilliseconds=timespan.fromHours(6).totalMilliseconds();
const TwentyHourTimespan=timespan.fromHours(20);let

ForecastDataService=class ForecastDataService extends LiveGroupBasedDataService{
constructor($timeout,dateService,statisticalDisplayDataService,groupTreeService,personalIncidentsService,displaySettingsService){
super($timeout,dateService,statisticalDisplayDataService,groupTreeService,displaySettingsService);

this._personalIncidentsService=personalIncidentsService;
}

async _fetchLatestData(...args){
const[options={}]=args;
const currentStatusSource=this._dateService.isMocked?'effectiveStatus':void 0;
const currentTimeForForecast=this._dateService.now();
const groupId=this._displaySettingsService.stickySettings.get('selectedGroupId');

const[
results,
{incidentTypes,incidentTypesByCode}={}]=
await Promise.all([
this._statisticalDisplayDataService.fetchForecastData(_.defaults({currentTimeForForecast,groupId,currentStatusSource},options)),
this._personalIncidentsService.getIncidentTypes()]);


return new Promise(resolve=>{
this._$timeout(()=>{
this.currentTimeForForecast=SocketResponse.safeDeserializeDate(results.currentTimeForForecast);
this.forecastRange=TimeInterval.from(results.visibleBounds.start).to(results.visibleBounds.end);
this.incidentTypesByCode=incidentTypesByCode;

resolve(results);
});
});
}

get currentlyLoadedGroupIds(){
return this._currentlyLoadedGroupIds;
}

get shouldReloadForLatestGroupData(){
if(!_.exists(this.groupTree)){
return!1;
}

const currentlySelectedGroupId=this._displaySettingsService.stickySettings.get('selectedGroupId');
return!this._currentlyLoadedGroupIds.has(currentlySelectedGroupId);
}};

module.exports=ForecastDataService;
//# sourceMappingURL=forecastDataService.js.map
